import { createSlice } from '@reduxjs/toolkit';
import {
  HandlersActionResponse,
  HandlersApprovalQueueItem,
} from '../athenaApiGen';
import { DEFAULT_TABLE_PAGE_SIZE } from '../../utils/tableVariables';

type TApprovalQueueState = {
  selectedEntity?: HandlersApprovalQueueItem;
  viewPanel: boolean;
  expandedPanel: boolean;
  allowedActions: HandlersActionResponse[];
  page: number;
  pageSize: number;
};

const initialState: TApprovalQueueState = {
  viewPanel: false,
  expandedPanel: false,
  allowedActions: [],
  page: 0,
  pageSize: DEFAULT_TABLE_PAGE_SIZE,
};

const approvalQueueSlice = createSlice({
  name: 'approvalQueue',
  initialState,
  reducers: {
    setEntity: (state, action) => {
      state.selectedEntity = action.payload;
    },
    setViewPanel: (state, action) => {
      state.viewPanel = action.payload;
      if (!action.payload) {
        state.expandedPanel = false;
      }
    },
    setExpandedPanel: (state, action) => {
      state.expandedPanel = action.payload;
    },
    setAllowedActions: (state, action) => {
      state.allowedActions = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
  },
});

const {
  setEntity,
  setViewPanel,
  setExpandedPanel,
  setPage,
  setPageSize,
  setAllowedActions,
} = approvalQueueSlice.actions;

export {
  setAllowedActions,
  setEntity,
  setExpandedPanel,
  setPage,
  setPageSize,
  setViewPanel,
};

export default approvalQueueSlice.reducer;
